import Action from './Action'
import Body, { Props as BodyProps } from './Body'
import Display from './Display'
import Page, { Props as PageProps } from './Page'
import TagList, { Props as TagListProps } from './TagList'

export type { BodyProps, PageProps, TagListProps }

export default { Action, Body, Display, Page, TagList }
